<template>
  <div>
    <NavBar />
    <div class="container main-container">
      <OrderList
        v-bind:orders="$store.state.laundryOrdersToReceive"
        v-bind:type="'TO_RECEIVE'"
        v-bind:mutable="true"
        v-bind:acceptText="'Recoger'"
        v-bind:rejectText="'Cancelar'"
        v-bind:onAcceptDialog="this.receive"
        v-bind:onRejectDialog="this.reject"
      />
    </div>
     <v-dialog v-model="showClaimDialog" scrollable max-width="300px">
      <v-card>
        <v-card-title>Reclamo</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <input v-model="claimType" type="radio" id="ml" name="Mal lavado" value="ml"><label for="1">Mal lavado</label><br/> 
          <input v-model="claimType" type="radio" id="pr" name="Prenda rota" value="pr"><label for="2">Prenda rota</label><br/> 
          <input v-model="claimType" type="radio" id="pe" name="Prenda erronea" value="pe"><label for="3">Prenda erronea</label><br/> 
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="showClaimDialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="sendClaim()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import OrderList from "../components/OrderList";
import NavBar from "../components/NavBar";

export default {
  name: "ordersToReceive",
  created() {
    this.getOrders();
  },
  components: {
    OrderList,
    NavBar
  },
  methods: {
    getOrders: function() {
      let self = this;
      self.$Progress.start();
      let url = this.$store.state.connection.url;
      /*
      Why is the POST method being used instead of a GET request?
      the XMLHttpRequest#send method does not send a body when performing
      a GET request, and odoo's json request handling throws a 400 error
      when not specifying a body in json requests.
      */
      self.$http
        .post(url + "orders?state=return", {
          body: {}
        })
        .then(result => {
          self.$Progress.finish();
          let orders = result.body.result.orders;
          self.$store.commit("updateLaundryOrders", orders);
        })
        .catch(err => {
          console.log(err);
          self.$Progress.finish();
        });
    },
    receive: function(event, order) {
      event.stopPropagation();
      var self = this;
      this.$dialog
        .confirm("Desea marcar este pedido como recibido?", {
          okText: "Aceptar",
          cancelText: "Cancelar"
        })
        .then(function(dialog) {
          let url = self.$store.state.connection.url;
          let endpoint = url + `orders/${order.id}/return`;

          self.$http
            .post(endpoint, {})
            .then(response => {
              if (response.body.result) {
                let updatedOrder = response.body.result;
                self.$store.commit("updateLaundryOrders", updatedOrder);
                self.$router.push('home');
              }
            })
            .catch(err => console.log(err));
        })
        .catch(err => console.log(err));
    },
    reject: function(event, order) {
      event.stopPropagation();
      this.$router.push({ name: 'ClaimOrder', params: { order: order } });
    }
  },
  data: function() {
    return {
      claimType: null,
      currentOrder: null,
      showClaimDialog: false,
      sendClaim: () => {
        event.stopPropagation()
        var self = this;
        this.$dialog
        .confirm("Desea marcar este pedido como rechazado?", {
          okText: "Aceptar",
          cancelText: "Cancelar"
        })
        .then(function(dialog) {
          window.console.log(self);
          let url = self.$store.state.connection.url;
          let endpoint = url + `orders/${self.currentOrder.id}/cancel`;

          self.$http
            .post(endpoint, {params: {claim_type: self.claimType}})
            .then(response => {
              if (response.body.result) {
                let updatedOrder = response.body.result;
                self.$store.commit("updateLaundryOrders", updatedOrder);
                self.showClaimDialog = false;
                self.claimType = null;
                self.currentOrder = null;
                self.$router.push('home');
              }
            })
            .catch(err => console.log(err));
        })
        .catch(err => console.log(err));
      },
      filteredOrders: () => {
        let results = {};
        for (var order in this.$store.state.orders) {
          if (this.$store.state.orders[order].status == "return")
            results[order] = this.$store.state.orders[order];
        }

        if (JSON.stringify(results) === JSON.stringify({})) return undefined;
        return results;
      }
    };
  }
};
</script>

<style>
.md-dialog {
  max-width: 768px;
}
</style>
